/**
 * Escape currency dollar signs so remark-math does not treat them as math delimiters.
 *
 * The chat renders answers with remark-math, where text between two "$" signs becomes inline
 * math. Two currency amounts in one answer ("$227 billion ... $132.4 billion") then rendered as
 * one garbled math span (TF-22). A "$" directly before a digit is a currency amount, so it is
 * escaped; a "$" that is already escaped, or that does not precede a digit (real math such as
 * "$x^2$"), is left alone.
 */
export const escapeCurrencyDollars = (content: string): string =>
  content.replace(/(?<!\\)\$(?=\d)/g, '\\$');
